
(async () => {

  if (!customElements.get('video-banner')) {

    class VideoBanner extends HTMLElement {
      constructor() {
        super();

        this.videoMobile = this.querySelector('[data-video-mobile]');
        this.videoDesktop = this.querySelector('[data-video-desktop]');
        this.button = this.querySelector('[data-video-button]');

        this.button?.addEventListener('click', this.toggleState.bind(this));
      }

      toggleState() {
        this.classList.toggle('playing');

        const target = window.innerWidth < 768 ? this.videoMobile : this.videoDesktop;

        if(target.paused) {
          target.play();
        } else {
          target.pause();
        }
      }
    }

    window.VideoBanner = VideoBanner;
    customElements.define('video-banner', VideoBanner);

  }
})();
